/**
 * Hero 3D protein bucket — pointer parallax + idle float
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScene(scene) {
    var tilt = scene.querySelector('[data-hero-bucket-tilt]');
    if (!tilt || REDUCED) return;

    var bounds = { w: 0, h: 0 };
    var target = { x: 0, y: 0 };
    var current = { x: 0, y: 0 };
    var rafId = null;

    function measure() {
      bounds.w = scene.offsetWidth;
      bounds.h = scene.offsetHeight;
    }

    function onMove(event) {
      var rect = scene.getBoundingClientRect();
      var cx = rect.left + rect.width * 0.5;
      var cy = rect.top + rect.height * 0.5;
      var dx = (event.clientX - cx) / (rect.width * 0.5);
      var dy = (event.clientY - cy) / (rect.height * 0.5);
      target.x = Math.max(-1, Math.min(1, dx)) * 10;
      target.y = Math.max(-1, Math.min(1, dy)) * -6;
    }

    function onLeave() {
      target.x = 0;
      target.y = 0;
    }

    function tick() {
      current.x += (target.x - current.x) * 0.08;
      current.y += (target.y - current.y) * 0.08;
      tilt.style.setProperty('--bucket-tilt-x', current.y.toFixed(2) + 'deg');
      tilt.style.setProperty('--bucket-tilt-y', current.x.toFixed(2) + 'deg');
      rafId = requestAnimationFrame(tick);
    }

    measure();
    window.addEventListener('resize', measure);
    scene.addEventListener('pointermove', onMove, { passive: true });
    scene.addEventListener('pointerleave', onLeave);
    rafId = requestAnimationFrame(tick);

    return function () {
      window.removeEventListener('resize', measure);
      scene.removeEventListener('pointermove', onMove);
      scene.removeEventListener('pointerleave', onLeave);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }

  function boot() {
    document.querySelectorAll('[data-hero-bucket]').forEach(initScene);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
